import React, { useState, useEffect } from 'react';
import { HeadingText, Col, Row, Container, TextDisplay, Button, DropdownMenu, TextArea, BodyText, Dialog, Alert } from '@paypalcorp/pp-react';
import * as linksURL from '../../../../constants/links.json';
import { get } from 'lodash';
import * as FPT from '../../utility/fpt';
import { LogoContainer } from './LogoContainer';
import ExtendSession from '../../ppgf/components/ExtendSession';
import withTheme from '../../common/withTheme';
import ReactHtmlParser from 'react-html-parser';

const EditProfile = (props) => {
    const messages = props.givingMessages;
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');
    const [cancelModal, setCancelModal] = useState(false);
    const [description, setDescription] = useState({ name: 'description', value: get(props.charityInfo, 'description', '') });
    const [keywords, setKeywords] = useState({ name: 'keywords', value: get(props.charityInfo, 'keywords', '') });
    const [slogan, setSlogan] = useState({ name: 'slogan', value: get(props.charityInfo, 'slogan', '') });
    const [missionArea, setMissionArea] = useState({ name: 'missionArea', value: `${get(props.charityInfo, 'missionArea.id', '')}` });
    const [missionAreaSecond, setMissionAreaSecond] = useState({ name: 'missionAreaSecond', value: `${get(props.charityInfo, 'missionAreaSecond.id', '')}` });
    const [missionAreaThird, setMissionAreaThird] = useState({ name: 'missionAreaThird', value: `${get(props.charityInfo, 'missionAreaThird.id', '')}` });
    const [logo, setLogo] = useState({ defaultLogoSrc: get(props.charityInfo, 'logo_url', ''), src: get(props.charityInfo, 'logo_url', ''), error: '', openModal: false });
    const missionAreaList = JSON.parse(document.getElementById('data-mission-area-list') && document.getElementById('data-mission-area-list').innerHTML || '[]');
    const missionAreas = missionAreaList.map((missionArea) => {
        return {
            value: `${missionArea.id}`,
            primaryText: messages[`${missionArea.id}`]
        }
    });

    const enrollTerms = messages?.profile?.enrollTerms.replace('{ppgfPrivacy}', get(linksURL.links[props.country], 'ppgfPrivacy', ''));
    
    const handleQuitModal = (open) => {
        open ? FPT.trackButtonClick('DisplayQuitProfileModal') : FPT.trackButtonClick('FinishProfileModal');
        setCancelModal(open);
    }

    const handleTextAreaChange = (e, setValue) => {
        setValue({ name: e.target.name, value: e.target.value, errorText: (!e.target.value && messages.profile.field.error.required) });
    }

    const handleMissionAreaChange = (e, setValue) => {
        let valueObj = { name: e.target.name, value: e.target.value };
        if (e.target.name === 'missionArea' && !e.target.value)
            valueObj.errorText = messages.profile.field.error.required;
        setValue(valueObj);
    }

    const validateForm = () => {
        let errorFields = [];
        if (!logo.src) {
            errorFields.push('logo');
            setLogo({ error: 'logo-missing' });
        }
        props.validateField(description, errorFields, setDescription);
        props.validateField(slogan, errorFields, setSlogan);
        props.validateField(missionArea, errorFields, setMissionArea);
        props.validateField(keywords, errorFields, setKeywords);
        if (missionAreaSecond.value && (missionAreaSecond.value === missionArea.value)) {
            errorFields.push('missionAreaSecond');
            setMissionAreaSecond({ name: 'missionAreaSecond', value: missionAreaSecond.value, errorText: messages.profile.missionArea.error.duplicate });
        }
        if (missionAreaThird.value && (missionAreaThird.value === missionArea.value || missionAreaThird.value === missionAreaSecond.value)) {
            errorFields.push('missionAreaSecond');
            setMissionAreaThird({ name: 'missionAreaThird', value: missionAreaThird.value, errorText: messages.profile.missionArea.error.duplicate });
        }
        return errorFields;
    }

    const onProfileSubmit = () => {
        let errorFields = validateForm();
        if (errorFields.length > 0) {
            if (errorFields[0] === 'logo') {
                window.scrollTo(0, 0);
            } else {
                document.getElementsByName(errorFields[0])[0].focus();
                return;
            }
            FPT.trackButtonClick('profileFormSubmitErr');
        } else {
            const payload = {
                description: description.value,
                slogan: slogan.value,
                keywords: keywords.value,
                missionArea: missionArea.value,
                missionAreaSecond: missionAreaSecond.value,
                missionAreaThird: missionAreaThird.value,
                logo: logo.file
            };
            FPT.trackButtonClick( props.manualEnroll ? 'enrollSubmitBtn' : 'profileEditSubmitBtn');
            props.onSubmitProfileForm(payload);
        }
    }

    const handleLogoSave = () => {
        let logoObj = { ...logo };
        logoObj.openModal = false;
        FPT.trackButtonClick('SaveLogoBtn');
        setLogo(logoObj);
    }

    useEffect(() => {
        FPT.trackPage(props.manualEnroll ? 'main:givingfund:enroll' : 'main:givingfund:editProfile');
    }, [])

    return (<>
        <ExtendSession scaCountry={pageDetails.scaCountry} basePage="editProfile" />
        <Dialog isOpen={cancelModal} hideTitle={true} closeButtonLabel={messages.profile.cancel} center={true} onClose={() => handleQuitModal(false)}>
            <Row style={{ marginBottom: '2rem' }}>
                <Col>
                    <img src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg" width="72px" height="72px" alt={messages.profile.update.closeModal.head} />
                </Col>
            </Row>
            <HeadingText style={{ marginBottom: '2rem' }} size="sm">{messages.profile.update.closeModal.head}</HeadingText>
            <Row >
                <Col>
                    <Button onClick={() => handleQuitModal(false)}>{messages.profile.update.closeModal.finishBtn}</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button style={{ marginBottom: '3rem' }} tertiary onClick={() => { props.setProfileEditView('', 'quitProfileFormBtn') }}>{messages.profile.update.closeModal.quitBtn}</Button>
                </Col>
            </Row>
        </Dialog>
        <HeadingText size="lg" className="editProfileHead">{messages.profile.head}</HeadingText>
        <Container className="profile" form>
            {props.charityInfo.error &&
                <Row className="serviceError">
                    <Col md={{ span: 8, offset: 2 }}>
                        <Alert type="error">
                            {messages.profile.serviceError}
                        </Alert>
                    </Col>
                </Row>}
            <Row style={{ marginBottom: '0.75rem' }}>
                <Col md={{ span: 8, offset: 2 }}>
                    <HeadingText size="sm">{messages.profile.logo.addHead}</HeadingText>
                    <BodyText>{messages.profile.logo.bodyText}</BodyText>
                </Col>
            </Row>
            <Row style={{ marginBottom: '1.5rem' }}>
                <Col md={{ span: 8, offset: 2 }}>
                    <LogoContainer onSave={handleLogoSave} logo={logo} setLogo={setLogo} charityInfo={props.charityInfo} />
                </Col>
            </Row>
            <Row className="editFieldHead">
                <Col md={{ span: 8, offset: 2 }}>
                    <HeadingText size="sm">{messages.profile.description.head}</HeadingText>
                    <TextDisplay name="descriptionText" value={messages.profile.description.bodyText} />
                </Col>
            </Row>
            <Row className="editField">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextArea
                        label={messages.profile.description.label}
                        maxRows={2} maxLength="511" maxCharacters="511"
                        showCharacterCounter {...description}
                        onBlur={(e) => handleTextAreaChange(e, setDescription)}
                        onChange={(e) => handleTextAreaChange(e, setDescription)} />
                </Col>
            </Row>
            <Row className="editFieldHead">
                <Col md={{ span: 8, offset: 2 }}>
                    <HeadingText size="sm">{messages.profile.slogan.head}</HeadingText>
                    <TextDisplay name="sloganText" value={messages.profile.slogan.bodyText} />
                </Col>
            </Row>
            <Row className="editField">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextArea
                        label={messages.profile.slogan.label}
                        maxLength="90" maxCharacters="90"
                        showCharacterCounter {...slogan}
                        onBlur={(e) => handleTextAreaChange(e, setSlogan)}
                        onChange={(e) => handleTextAreaChange(e, setSlogan)} />
                </Col>
            </Row>
            <Row className="editFieldHead">
                <Col md={{ span: 8, offset: 2 }}>
                    <HeadingText size="sm">{messages.profile.missionArea.head}</HeadingText>
                    <TextDisplay name="missionAreasText" value={messages.profile.missionArea.bodyText} />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }} >
                    <DropdownMenu
                        options={missionAreas}
                        id="missionArea"
                        label={messages.profile.missionArea.pimaryLabel}
                        {...missionArea}
                        onChange={(event) => {
                            event.target.name = 'missionArea';
                            handleMissionAreaChange(event, setMissionArea)
                        }} />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <DropdownMenu
                        options={missionAreas}
                        id="missionAreaSecond"
                        label={messages.profile.missionArea.secondaryLabel}
                        {...missionAreaSecond}
                        onChange={(event) => {
                            event.target.name = 'missionAreaSecond';
                            handleMissionAreaChange(event, setMissionAreaSecond)
                        }} />
                </Col>
            </Row>
            <Row>
                <Col md={{ span: 8, offset: 2 }}>
                    <DropdownMenu
                        options={missionAreas}
                        id="missionAreaThird"
                        label={messages.profile.missionArea.secondaryLabel}
                        {...missionAreaThird}
                        onChange={(event) => {
                            event.target.name = 'missionAreaThird';
                            handleMissionAreaChange(event, setMissionAreaThird)
                        }} />
                </Col>
            </Row>
            <Row className="editFieldHead">
                <Col md={{ span: 8, offset: 2 }}>
                    <HeadingText size="sm">{messages.profile.keywords.head}</HeadingText>
                    <TextDisplay name="keywordsText" value={messages.profile.keywords.bodyText} />
                </Col>
            </Row>
            <Row className="editField">
                <Col md={{ span: 8, offset: 2 }} style={{ marginBottom: '2.5rem' }}>
                    <TextArea
                        label={messages.profile.keywords.label}
                        maxRows={2} maxLength="255" maxCharacters="255"
                        showCharacterCounter {...keywords}
                        onBlur={(e) => handleTextAreaChange(e, setKeywords)}
                        onChange={(e) => handleTextAreaChange(e, setKeywords)} />
                </Col>
            </Row>
            {props.manualEnroll && <Row>
                <Col md={{ span: 8, offset: 2 }} style={{ marginBottom: '2.5rem' }}>
                    {ReactHtmlParser(enrollTerms)}                    
                </Col>
            </Row>}
            <Row>
                <Col style={{ textAlign: 'center', marginBottom: '0.75rem' }} >
                    <Button onClick={onProfileSubmit}>{props.manualEnroll ? messages.profile.agree : messages.profile.save}</Button>
                </Col>
            </Row>
            <Row>
                <Col style={{ textAlign: 'center', marginBottom: '0.75rem' }}>
                    <Button tertiary onClick={() => handleQuitModal(true)}>{props.manualEnroll ? messages.profile.enrollLater : messages.profile.cancel}</Button>
                </Col>
            </Row>
        </Container>
    </>);
}

export default withTheme(EditProfile);